export default {
  login: {
    title: 'Log in',
    subtitle: 'Welcome to OÖML Activities',
    email: 'Email',
    email_placeholder: 'Enter your email',
    password: 'Password',
    password_placeholder: 'Enter your Password',
    email_restore_placeholder: 'Enter your email',
    confirm_password: 'Confirm password',
    confirm_placeholder: 'Enter your confirm Password',
    forgot_password: 'Forgot password',
    forgot_subtitle: 'No worries, we’ll send you reset instructions.',
    submit: 'Log in',
    reset: 'Reset password',
    back_to_login: 'Back to log in',
    check_email: 'Check your email',
    check_email_text:
      'Password restore instructions have been sent to your email',
    receive_email: 'Didn’t receive the email?',
    click_resend: 'Click to resend',
    password_reset: 'Password reset',
    current_password: 'Current password',
    new_password_change: 'New password',
    current_password_placeholder: 'Enter your current password',
    new_password_change_placeholder: 'Enter your new password',
    password_success:
      'Your password has been successfully reset. Click below to log in magically.',
    continue: 'Continue',
    new_password: 'Set new password',
    new_password_subtitle:
      'Your new password must be different to previously used passwords.',
    logout_text: 'Do you want to logout?',
    invite: 'Successfully',
    invite_success:
      'You have successfully registered. Click below to log in magically.',
    change_password: 'Change password',
    deactivated:
      'Your account is currently deactivated. Please contact your supervisor in order to reactivate your account',
  },
  symbol: {
    character: 'At least 6 characters',
    uppercase: 'A mixture of both uppercase and lowercase letters',
    number: 'A mixture of letters and numbers.',
    special_character: 'Inclusion of at least one special character, e.g.',
    password_requires:
      'The password requires an uppercase, lowercase, number and special character',
  },
}
